<template>
  <div v-if="hasFeature('FEATURE_ORDERBOXES') && order.box && order.status != 'empty'" class="control__single" v-hammer:tap="onClick" v-hammer:press="onLongClick">
    <div class="control__box">box {{ order.box }}</div>
    <div class="control__number control__number--no-top-padding">{{ order.number | fwgshortorder }}</div>
    <div class="control__badge control__badge--pager" v-if="order.pagernumber">p</div>
    <div class="control__badge control__badge--tracker" v-if="order.trackernumber">t</div>
  </div>
  <div v-else-if="hasFeature('FEATURE_ORDERBOXES') && order.box" class="control__single" v-hammer:tap="onClick" v-hammer:press="onLongClick">
    <div class="control__box control__box--empty">box {{ order.box }}</div>
  </div>
  <div v-else :key="order.id" class="control__single" v-hammer:tap="onClick" v-hammer:press="onLongClick">
    <div class="control__number">{{ order.number | fwgshortorder }}</div>
    <div class="control__badge control__badge--pager" v-if="order.pagernumber">p</div>
    <div class="control__badge control__badge--tracker" v-if="order.trackernumber">t</div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      required: true
    },
  },
  methods: {
    onClick() {
      this.$emit("click")
    },
    onLongClick() {
      this.$emit("edit")
    }
  }
}
</script>

<style>
</style>
